import SectionShell from "./SectionShell";

// Layout primitive shared by every "something on a choosable side" variant. The
// supporting content is an <aside> — it is complementary to the body either way
// — and `side` decides which side the stylesheet orders it to.
export default function SplitSection(props: {
  variant: string;
  title?: string;
  side?: CaseStudySide;
  aside: any;
  children?: any;
}) {
  const { variant, title, side = "right", aside, children } = props;

  return (
    <SectionShell variant={variant} title={title}>
      <div className="case-split">
        <aside className={`case-split-aside case-split-aside--${side}`}>{aside}</aside>
        <div className="case-split-main">{children}</div>
      </div>
    </SectionShell>
  );
}
